/* ==============================================
   KĀRU Product Widget JS
   Extracted from snippets/product-form.liquid
   ============================================== */

document.addEventListener('DOMContentLoaded', function() {

  /* ==============================================
     FETCH INTERCEPTOR – Selling Plan in /cart/add
     ============================================== */
  (function() {
    var originalFetch = window.fetch;
    window.fetch = function(url, options) {
      if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
        var spInput = document.getElementById('karu-selling-plan-input');
        var spValue = spInput ? spInput.value : '';
        if (options && options.body) {
          try {
            if (typeof options.body === 'string') {
              var data = JSON.parse(options.body);
              if (spValue) { data.selling_plan = parseInt(spValue); }
              else { delete data.selling_plan; }
              options.body = JSON.stringify(data);
            } else if (options.body instanceof FormData) {
              if (spValue) { options.body.set('selling_plan', spValue); }
              else { options.body.delete('selling_plan'); }
            }
          } catch(e) {}
        }
      }
      return originalFetch.apply(this, arguments);
    };
  })();

  /* ==============================================
     HELPERS
     ============================================== */
  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' \u20AC';
  }

  /* Product Variants Data (für Preisanzeige) */
  var rawVariantsData = document.getElementById('karu-product-variants');
  var productVariants = rawVariantsData ? JSON.parse(rawVariantsData.textContent) : [];

  function findVariantById(id) {
    var numId = parseInt(id);
    return productVariants.find(function(v) { return v.id === numId; });
  }

  /* Read config from data attributes */
  var widget = document.getElementById('karu-widget');
  var formId = widget ? widget.getAttribute('data-form-id') : null;

  function getActiveVariantId() {
    var activeCard = document.querySelector('.karu-variant-card--active');
    if (activeCard) return activeCard.getAttribute('data-variant-id');
    if (!formId) return null;
    var form = document.getElementById(formId);
    if (!form) return null;
    var idInput = form.querySelector('input[name="id"]');
    return idInput ? idInput.value : null;
  }

  /* ==============================================
     VARIANT CARD ACTIVE STATE + VARIANT CHANGE
     ============================================== */
  var variantCards = document.querySelectorAll('.karu-variant-card');

  function syncCardActiveStates() {
    variantCards.forEach(function(card) {
      var radio = card.querySelector('.block-swatch__radio');
      if (radio) {
        card.classList.toggle('karu-variant-card--active', radio.checked);
      }
    });
  }

  function handleVariantCardChange(radio) {
    syncCardActiveStates();

    var card = radio.closest('.karu-variant-card');
    var variantId = card ? card.getAttribute('data-variant-id') : null;
    if (!variantId) return;

    var form = formId ? document.getElementById(formId) : null;
    if (!form) return;

    /* Hidden input updaten */
    var idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.value = variantId;

    /* URL updaten */
    if (history.replaceState) {
      var newUrl = new URL(window.location.href);
      newUrl.searchParams.set('variant', variantId);
      history.replaceState({ path: newUrl.toString() }, '', newUrl.toString());
    }

    /* variant:changed dispatchen für ProductMeta (Preisanzeige) */
    var variant = findVariantById(variantId);
    if (variant) {
      form.dispatchEvent(new CustomEvent('variant:changed', {
        bubbles: true,
        detail: { variant: variant }
      }));
    }

    onVariantChanged();
  }

  if (variantCards.length > 0) {
    variantCards.forEach(function(card) {
      var radio = card.querySelector('.block-swatch__radio');
      if (!radio) return;
      radio.addEventListener('change', function() {
        handleVariantCardChange(radio);
      });
    });

    variantCards.forEach(function(card) {
      card.addEventListener('click', function() {
        var radio = card.querySelector('.block-swatch__radio');
        if (!radio) return;
        setTimeout(function() {
          if (radio.checked) {
            handleVariantCardChange(radio);
          }
        }, 0);
      });
    });
  }

  /* ==============================================
     UNIFIED WIDGET – Tab Switching + Abo Logic
     ============================================== */
  if (!widget) return;

  var tabs = widget.querySelectorAll('.karu-widget__tab');
  var aboInfo = document.getElementById('karu-abo-info');
  var frequencySelect = document.getElementById('karu-frequency-select');
  var sellingPlanInput = document.getElementById('karu-selling-plan-input');
  var rawData = document.getElementById('karu-selling-plans-data');
  var sellingPlansData = rawData ? JSON.parse(rawData.textContent) : {};
  var ctaText = document.getElementById('karu-cta-text');
  var ctaTextEinmal = widget.getAttribute('data-cta-einmal') || 'In den Warenkorb';
  var ctaTextAbo = widget.getAttribute('data-cta-abo') || 'Abo starten';
  var currentTab = 'once';

  /* Tab-Switch */
  function switchTab(tab) {
    currentTab = tab;

    tabs.forEach(function(t) {
      t.classList.toggle('karu-widget__tab--active', t.dataset.tab === tab);
    });

    if (aboInfo) {
      aboInfo.style.display = (tab === 'abo') ? 'block' : 'none';
    }

    updateCardPrices();

    if (tab === 'abo') {
      var variantId = getActiveVariantId();
      var vd = sellingPlansData[variantId];
      if (vd && vd.plans.length > 0) {
        populateFrequency(vd.plans);
        sellingPlanInput.value = vd.plans[0].id;
      }
      if (ctaText) ctaText.textContent = ctaTextAbo;
    } else {
      if (sellingPlanInput) sellingPlanInput.value = '';
      if (ctaText) ctaText.textContent = ctaTextEinmal;
    }
  }

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      if (this.classList.contains('karu-widget__tab--disabled')) return;
      switchTab(this.dataset.tab);
    });
  });

  /* Card-Preise updaten basierend auf Tab */
  function updateCardPrices() {
    variantCards.forEach(function(card) {
      var priceEl = card.querySelector('.karu-variant-card__price');
      var compareEl = card.querySelector('[data-compare-display]');
      if (!priceEl) return;

      var oncePrice = parseInt(priceEl.getAttribute('data-once-price'));
      var aboPrice = priceEl.getAttribute('data-abo-price');

      if (currentTab === 'abo' && aboPrice) {
        priceEl.textContent = formatMoney(parseInt(aboPrice));
        if (compareEl) {
          compareEl.textContent = formatMoney(oncePrice);
          compareEl.style.display = '';
        }
      } else {
        priceEl.textContent = formatMoney(oncePrice);
        if (compareEl) {
          compareEl.style.display = 'none';
        }
      }
    });
  }

  /* Frequenz befüllen */
  function populateFrequency(plans) {
    if (!frequencySelect) return;
    var currentVal = frequencySelect.value;
    frequencySelect.innerHTML = '';
    plans.forEach(function(plan, i) {
      var opt = document.createElement('option');
      opt.value = plan.id;
      opt.textContent = plan.name;
      if (String(plan.id) === currentVal) opt.selected = true;
      else if (i === 0 && !currentVal) opt.selected = true;
      frequencySelect.appendChild(opt);
    });
  }

  /* Frequenz-Wechsel */
  if (frequencySelect) {
    frequencySelect.addEventListener('change', function() {
      if (sellingPlanInput) sellingPlanInput.value = this.value;
    });
  }

  /* Variante gewechselt → Abo-Tab prüfen */
  function onVariantChanged() {
    var variantId = getActiveVariantId();
    var vd = sellingPlansData[variantId];
    var aboTab = widget.querySelector('[data-tab="abo"]');

    if (!vd || vd.plans.length === 0) {
      if (aboTab) aboTab.classList.add('karu-widget__tab--disabled');
      if (currentTab === 'abo') switchTab('once');
    } else {
      if (aboTab) aboTab.classList.remove('karu-widget__tab--disabled');
      if (currentTab === 'abo') {
        populateFrequency(vd.plans);
        sellingPlanInput.value = vd.plans[0].id;
      }
    }

    updateCardPrices();
  }

  /* Theme variant:changed event (für externe Variantenwechsel, z.B. Farbswatches) */
  document.addEventListener('variant:changed', function() {
    syncCardActiveStates();
    onVariantChanged();
  });

  /* Initial */
  onVariantChanged();
  updateCardPrices();

});
